/**
 * API de tipos de categoría (categoryType.php)
 * GET / → lista | GET /{id} → por ID | GET ?type={nombre} o /{nombre} → por nombre
 * POST / → crear | PUT|PATCH /{id} → actualizar | DELETE /{id} → eliminar
 */

import { dotoniwoofApi } from '../api/dotoniwooApi';

const BASE = '/categoryType.php';

export const getCategoryTypes = async () => {
  try {
    const response = await dotoniwoofApi.get(BASE);
    return {
      ok: true,
      status: response.status,
      data: response.data
    };
  } catch (error) {
    console.error('Error al obtener tipos de categoría:', error);
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error de conexión' }
    };
  }
};

export const getCategoryTypeById = async (id) => {
  try {
    const response = await dotoniwoofApi.get(`${BASE}/${id}`);
    return {
      ok: true,
      status: response.status,
      data: response.data
    };
  } catch (error) {
    console.error('Error al obtener tipo de categoría:', error);
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error de conexión' }
    };
  }
};

export const createCategoryType = async (payload) => {
  try {
    const response = await dotoniwoofApi.post(BASE, payload);
    return {
      ok: true,
      status: response.status,
      data: response.data
    };
  } catch (error) {
    console.error('Error al crear tipo de categoría:', error);
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error al crear tipo' }
    };
  }
};

export const updateCategoryType = async (id, payload) => {
  try {
    const response = await dotoniwoofApi.put(`${BASE}/${id}`, payload);
    return {
      ok: true,
      status: response.status,
      data: response.data
    };
  } catch (error) {
    console.error('Error al actualizar tipo de categoría:', error);
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error al actualizar tipo' }
    };
  }
};

export const deleteCategoryType = async (id) => {
  try {
    const response = await dotoniwoofApi.delete(`${BASE}/${id}`);
    return {
      ok: true,
      status: response.status,
      data: response.data
    };
  } catch (error) {
    console.error('Error al eliminar tipo de categoría:', error);
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error al eliminar tipo' }
    };
  }
};
